import React, { PureComponent } from 'react';
import * as _ from 'lodash';

class Loading extends PureComponent {

    constructor(props) {
        super(props);

        this.loadingGifs = [
            "https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif"
        ];

        this.errorGifs = [
            "https://media.giphy.com/media/D8kdCAJIoSQ6I/giphy.gif",
            "https://media.giphy.com/media/mq5y2jHRCAqMo/giphy.gif"
        ];
    }

    getGif() {
        const arr = this.props.isError ? this.errorGifs : this.loadingGifs;
        return _.shuffle(arr)[0];
    }

    render() {
        return (
            <div className="uk-container">
                {this.props.children}
                <img src={this.getGif()} alt="" />
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/Loading.js